import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/home';
export function TestimonialsSection() {
  return <section className="bg-cool-gray py-24 md:py-32" data-id="element-202" data-mp="1n00ndswrwjqe">
      <div className="max-w-7xl mx-auto px-6" data-id="element-203" data-mp="1mziun69bknn8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl mb-16 space-y-5" data-id="element-204" data-mp="1r1dvk9nc8z0h">
          <span className="text-royal-blue text-xs font-bold uppercase tracking-[0.2em]" data-id="element-205" data-mp="142zgu3nkmbkc">
            Client Success Stories
          </span>
          <h2 className="text-midnight-navy text-3xl md:text-5xl font-montserrat font-extrabold leading-tight tracking-tight" data-id="element-206" data-mp="2yfgzexxgsnin">
            Results our clients can measure.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-207" data-mp="2v12leyqzkfa4">
          {testimonials.map((item, idx) => <motion.figure key={item.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1,
          ease: 'easeOut'
        }} className="bg-stark-white p-8 rounded-2xl border border-midnight-navy/10 shadow-sm flex flex-col" data-id="element-208" data-mp="2q39h6b98tvch" data-mpi={idx}>
              <QuoteIcon className="w-8 h-8 text-royal-blue/30 mb-6" data-id="element-209" data-mp="2h19y7deo4h6w" />
              <blockquote className="text-midnight-navy/70 leading-relaxed flex-grow" data-id="element-210" data-mp="2h45xb5295bwx">
                {item.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-midnight-navy/10" data-id="element-211" data-mp="3sfwyt45gh7ao">
                <div className="text-midnight-navy font-montserrat font-bold" data-id="element-212" data-mp="3fad2n09r1rm">
                  {item.name}
                </div>
                <div className="text-midnight-navy/40 text-sm" data-id="element-213" data-mp="8ck76fyls1ls">{item.role}</div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}